/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

/**
 * User is a "site editor", allowing them to modify CMS pages.
 */
export const SITE_EDITOR = 'cmsSiteEditor';
